import forge from 'node-forge'

const Key = process.env.VUE_APP_CRYPTO_KEY
const IV = process.env.VUE_APP_CRYPTO_IV

export function Encryption(data) {
  try {
    const secretKey = forge.util.createBuffer(Key)
    const iv = forge.util.createBuffer(IV)
    const cipher = forge.cipher.createCipher('AES-CBC', secretKey)

    cipher.start({ iv: iv })
    cipher.update(forge.util.createBuffer(JSON.stringify(data)))
    cipher.finish()

    return forge.util.encode64(cipher.output.data)
  } catch (e) {
    console.log(e)
    return null
  }
}

export function Decryption(encryptedData) {
  try {
    const secretKey = forge.util.createBuffer(Key)
    const iv = forge.util.createBuffer(IV)
    const decipher = forge.cipher.createDecipher('AES-CBC', secretKey)

    const decodedData = forge.util.decode64(encryptedData)
    decipher.start({ iv: iv })
    decipher.update(forge.util.createBuffer(decodedData))
    const result = decipher.finish()

    if (result) {
      const decryptedData = forge.util.decodeUtf8(decipher.output.data)
      return JSON.parse(decryptedData)
    } else {
      console.log('Decryption failed')
      return null
    }
  } catch (e) {
    console.log(e)
    return null
  }
}